var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 91,
    viewBox: "0 0 202 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2923 79.0925L44.797 87.8041C45.1417 88.2626 45.8772 88.2855 46.222 87.8041L52.7266 79.0925C100.213 69.2346 94.0299 1.28382 45.5095 0C-3.03392 1.30674 -9.23975 69.2116 38.2923 79.0925ZM45.5095 17.0106C58.151 17.0106 68.4251 27.2582 68.4251 39.8672C67.2759 70.1974 23.7431 70.1745 22.5939 39.8672C22.5939 27.2582 32.868 17.0106 45.5095 17.0106Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.446 80.6992L154.756 87.7831C155.1 88.2416 155.836 88.2645 156.181 87.7831L161.49 80.6992C200.61 72.469 195.392 16.5311 155.468 15.4766C115.521 16.5311 110.326 72.469 149.446 80.6992ZM155.468 32.6247C176.338 33.2666 176.361 63.4593 155.468 64.1012C134.575 63.4135 134.621 33.2896 155.468 32.6247Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.461 106.21H166.225C162.984 96.0769 147.975 96.054 144.78 106.21H56.2205C53.0717 96.054 37.9708 96.0998 34.7759 106.21H3.53993C-1.10296 106.279 -1.24086 113.294 3.53993 113.363H34.753C38.0168 123.541 53.0487 123.564 56.2665 113.363H144.757C147.929 123.541 163.053 123.519 166.271 113.363H197.484C202.127 113.317 202.264 106.302 197.484 106.21H197.461Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4959",
    x: 0.00585938,
    y: 0,
    width: 201.012,
    height: 125.008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.ace6929676fecff69059f40d7998355d.svg";
export { ForwardRef as ReactComponent };